import React, { useState } from 'react';
import SpeciesList from './SpeciesList';

const stateNames = [
    'Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia',
    'Fed. States of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'lowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana',
    'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands',
    'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee',
    'Texas', 'US Minor Outlying Islands', 'Utah', 'Vermont', 'Virginia', 'Virgin Islands', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

const Search = () => {
    const [selectedState, setSelectedState] = useState('');
    const [speciesData, setSpeciesData] = useState([]);

    const handleStateChange = (event) => {
        setSelectedState(event.target.value);
    };


    const searchSpecies = async () => {
        if (stateNames.includes(selectedState)) {
            const encodedStateName = encodeURIComponent(selectedState);
            const originalURL = "https://ecos.fws.gov/ecp/pullreports/catalog/species/report/species/export?format=json&columns=%2Fspecies%40cn%2Csn%2Cstatus%2Clisting_date%3B%2Fspecies%2Frange_state%40abbrev%3B%2Fspecies%2Frange_country%40name%3B%2Fspecies%2FspeciesImage%40image_url%3B%2Fspecies%40gn&sort=%2Fspecies%40sn%20asc&filter=%2Fspecies%40gn%20%3D%20'birds'%20or%20%2Fspecies%40gn%20%3D%20'mammals'%20or%20%2Fspecies%40gn%20%3D%20'reptiles'%20or%20%2Fspecies%40gn%20%3D%20'Amphibians'%20or%20%2Fspecies%40gn%20%3D%20'Arachnids'%20or%20%2Fspecies%40gn%20%3D%20'Clams'%20or%20%2Fspecies%40gn%20%3D%20'Corals'%20or%20%2Fspecies%40gn%20%3D%20'Crustaceans'%20or%20%2Fspecies%40gn%20%3D%20'Fishes'%20or%20%2Fspecies%40gn%20%3D%20'Insects'%20or%20%2Fspecies%40gn%20%3D%20'Snails'&filter=%2Fspecies%2Frange_country%40name%20%3D%20'United%20States'&filter=%2Fspecies%2Frange_state%40name%20%3D%20";
            const updatedURL = originalURL + `%27${encodedStateName}%27`;

            try {
                const response = await fetch(updatedURL);
                if (response.ok) {
                    const data = await response.json();
                    console.log('Species data:', data);
                    setSpeciesData(data); // Assuming the API returns the data in a format that can be directly used
                } else {
                    console.error('Failed to fetch species data');
                }
            } catch (error) {
                console.error('Error fetching species data:', error);
            }
        } else {
            console.log(`Selected state '${selectedState}' is not in the list.`);
        }
    };

    return (
        <div className="flex flex-col items-center min-h-screen">
            <div className="w-full max-w-xs flex my-5">
                <select
                    className="block w-full px-4 py-2 border border-gray-500 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    value={selectedState}
                    onChange={handleStateChange}
                >
                    <option value="">Select a state</option>
                    {stateNames.map((state) => (
                        <option key={state} value={state}>{state}</option>
                    ))}
                </select>
                <button
                    className="w-full flex justify-center py-6 px-2 ml-3 border border-transparent rounded-md shadow-sm text-xl font-medium text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={searchSpecies}
                >
                    Search
                </button>
            </div>
            {speciesData.data && speciesData.data.length > 0 && (
                <div className='mx-20 mt-8'>
                    <SpeciesList speciesData={speciesData} />
                </div>
            )}
        </div>
    );    
};

export default Search;
